import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../../Reducer/loaderSlice";
import Handler from "../../../Helpers/Handler";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";

// const BASE = "http://localhost/business_community/";
const BASE = "https://qnexus.in/community/";
const limit = 8;

const MyPosts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const totalPages = Math.ceil(totalCount / limit);

  const fetchPosts = async (pageNo = 1) => {
    dispatch(loadingTrue());
    try {
      const offset = (pageNo - 1) * limit;
      const r = await Handler({
        method: "get",
        url: `/post/list.php?limit=${limit}&offset=${offset}`
      });
      if (r?.success) {
        setList(r.data.list || []);
        setTotalCount(r.data.total_count || 0);
        setPage(pageNo);
      }
    } catch (e) { Handler(e); }
    dispatch(loadingFalse());
  };

  useEffect(() => { fetchPosts(1); }, []);

  const openDeleteModal = (postId) => {
    setSelectedPostId(postId);
    setDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!selectedPostId) return;
    dispatch(loadingTrue());
    try {
      const res = await Handler({
        method: "post",
        url: "/post/delete.php",
        data: { post_id: selectedPostId }
      });
      if (res?.success) fetchPosts(page);
    } catch (e) { Handler(e); }
    dispatch(loadingFalse());
    setDeleteModal(false);
    setSelectedPostId(null);
  };

  return (
    <React.Fragment>
      <div className="myposts-wrapper">
        <h4 className="myposts-title">My Posts</h4>

        {/* GRID */}
        <div className="myposts-grid">
          {list && list?.map(post => {
            const media = post.media?.[0];
            const isText = post.post_type === "TEXT";

            return (
              <div key={post.id} className={`mypost-card ${isText ? "text-only" : ""}`}>

                {/* MEDIA — image/video posts only */}
                {!isText && (
                  <div className="mypost-media" onClick={() => navigate(`/user/view-post/${post.id}`, { state: { post } })}>
                    {media?.type?.toUpperCase() === "IMAGE" && (
                      <img src={BASE + media.url} alt="" />
                    )}
                    {media?.type?.toUpperCase() === "VIDEO" && (
                      <>
                        <video src={BASE + media.url} />
                        <div className="mypost-play"><i className="fa fa-play"></i></div>
                      </>
                    )}
                    <div className="mypost-overlay">
                      <span>❤️ {post.like_count}</span>
                      <span>💬 {post.comment_count}</span>
                    </div>
                  </div>
                )}

                {/* TEXT PLACEHOLDER — text posts only */}
                {isText && (
                  <div
                    className="mypost-text-banner"
                    onClick={() => navigate(`/user/view-post/${post.id}`, { state: { post } })}
                  >
                    <div className="mypost-text-placeholder">
                      <i className="bx bx-align-left" />
                      <span>Text Post</span>
                    </div>
                  </div>
                )}

                {/* INFO */}
                <div className="mypost-info">
                  

                  <div className="mypost-content">{post.content || "No caption"}</div>

                  <div className="mypost-stats">
                    <span>❤️ {post.like_count}</span>
                    <span>💬 {post.comment_count}</span>
                  </div>

                  <div className="mypost-date">
                    {moment(post.created_at).fromNow()}
                  </div>
                </div>

                {/* ACTIONS */}
                <div className="mypost-actions">
                  <button onClick={() => navigate(`/user/edit-post/${post.id}`, { state: { post } })}>Edit</button>
                  <button className="delete" onClick={() => openDeleteModal(post.id)}>Delete</button>
                </div>

              </div>
            );
          })}
        </div>

        {list?.length === 0 && <p className="text-center">No data found</p>}

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="myposts-pagination">
            <button disabled={page === 1} onClick={() => fetchPosts(page - 1)}>Prev</button>
            {[...Array(totalPages)]?.map((_, i) => (
              <button
                key={i}
                className={page === i + 1 ? "active" : ""}
                onClick={() => fetchPosts(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button disabled={page === totalPages} onClick={() => fetchPosts(page + 1)}>Next</button>
          </div>
        )}
      </div>

      {/* DELETE MODAL */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalBody style={{ textAlign: "center", padding: 24 }}>
          <h5 style={{ marginBottom: 10 }}>Delete Post?</h5>
          <p style={{ color: "#666", marginBottom: 20 }}>
            This action cannot be undone.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
            <button
              onClick={() => setDeleteModal(false)}
              style={{ padding: "8px 18px", borderRadius: 6, border: "1px solid #ccc", background: "#fff" }}
            >
              Cancel
            </button>
            <button
              onClick={confirmDelete}
              style={{ padding: "8px 18px", borderRadius: 6, border: "none", background: "#ff4d4f", color: "#fff", fontWeight: 600 }}
            >
              Delete
            </button>
          </div>
        </ModalBody>
      </Modal>

    </React.Fragment>
  );
};

export default MyPosts;